let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bwD1u")).then(() => parcelRequire('9pe3F'));